import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { auth, isLoading } = useContext(AuthContext);

  // 로딩 중일 때 스피너 등을 표시
  if (isLoading) {
    return <div>불러오는 중...</div>;
  }

  return auth.isAuthenticated ? children : <Navigate to="/" />;
};

export default PrivateRoute;
